import React from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'

import SEO from '../../components/seo'
import Navbar from '../../components/navbar_poc'
import AboutTwo from '../../components/about-two'
import CtaOne from '../../components/cta/cta-one'
import Partner from '../../components/partner'
import PricingTwo from '../../components/pricing-two'
import Footer from '../../components/footer'
import AboutThree from '../../components/about-three'
import phoneImg from '../../assets/images/startup/whyindia2.jpg'
import ClientThree from '../../components/client-three'
import PodcastPlayer2 from '../../components/podcast-player2'
import heroImg from '../../assets/images/B2BLogoRound.png'
import heroImg2 from '../../assets/images/homehero.jpg'
import heroImg3 from '../../assets/images/podcastlogo.jpg'
import heroImg4 from '../../assets/images/B2BBookCoverv3.jpg'
import heroImg5 from '../../assets/images/heroimg5.jpg'
import { lawyerServices } from '../../data/data'
import { featureData, skillData, teamData } from '../../data/poc'
import ClientLogoSlider from '../../components/ClientLogoSlider'
import aboutImg2 from '../../assets/images/team/siva.png'
import aboutImg3 from '../../assets/images/team/manjunath.png'
import ClientFour from '../../components/client-four'
import image1 from '../../assets/images/portfolio/customermap.png'
import image2 from '../../assets/images/portfolio/single02.jpg'
import image3 from '../../assets/images/portfolio/single03.jpg'
import bg1 from '../../assets/images/managment/whywestarted.jpg'
import { portfolioData, social } from '../../data/portfolio'
import VideoModalTwo from '../../components/video-modal-two'
import TinySlider from "tiny-slider-react";
import { about, footerLinks, footerPodcastB2B, footerSocialB2B, landing, location, serviceStages } from '../../data'
import 'tiny-slider/dist/tiny-slider.css';
import PodcastPlayer3 from '../../components/podcast-player3'
export default function IndexBridgeToBharath() {

    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault(); // prevent default form submission behavior
        navigate('/contact'); // redirect to /contact
    };
    let Images = [image1]
    const settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: false,
        rewind: true,
        autoplay: false,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
    };
    let params = useParams();
    let id = params.id;
    let data = portfolioData.find((item) => item.id === parseInt(id))
    return (
        <>
            <Navbar />
            <SEO
                title="Roots and Wings Podcast"
                description="A podcast about growth — personal, national, and global."
                url="https://www.pioneeroneglobal.com/podcast"
                image="https://www.pioneeroneglobal.com/images/option2.png"
            />


            <section className="bg-half-170 bg-light d-table w-100">
            <div className="container">
  <div className="row align-items-center mt-5">
    <div className="col-lg-6 col-md-5">
      <div className="me-lg-5">
        <img src={heroImg} className="img-fluid rounded" alt="" />
      </div>
    </div>

    <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
      <div className="title-heading mt-4">
        <h1 className="heading mb-3">Bridge to Bharath</h1>
        <p className="para-desc text-muted">
          A podcast for CEOs, strategy leaders, and global decision-makers navigating India’s opportunities and complexities.
        </p>
        <p className="text-muted description">
          When Smart Money Makes Dumb Mistakes — And How to Avoid Them in India
        </p>
      </div>

      {/* icons row */}
      <div className="d-flex mt-3">
        {footerPodcastB2B.map((item, index) => (
          <a
            key={index}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="podcast-button me-2"
          >
            <img
              src={item.image}
              style={{ height: "36px" }}
              alt="Podcasts"
            />
          </a>
        ))}
      </div>
      <div className="d-flex mt-3">
      {footerSocialB2B.map((item,index)=>{
                                      let Icon = item.icon
                                      
                                      return(
                                          <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><i className=" align-middle"><Icon style={{ color: item.color, fontSize: "24px" }} /></i></Link></li>
                                      )
                                  })}
      </div>

    </div>
  </div>
</div>

                <div className="container">
                    <div className="row align-items-center mt-5">
                          <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <div className="title-heading mt-4">
                                <h1 className="heading mb-3">About the Podcast</h1>
                                <p className="para-desc text-muted">India isn’t just another growth market — it’s a market that could make or break the next decade of global business.</p>
                                <p className="text-muted description">Yet between 2014–2021, over 2,800 foreign companies exited India, even as Micron, HubSpot, and Schibsted thrived. Why?</p>
                                <p className="text-muted description">Because India rewards preparation and punishes assumptions.</p>

                                <p className="text-muted description">Bridge to Bharath is your guide through this paradox. In each episode, we unpack real stories, practical frameworks, and proven strategies to help you:</p>

                                <ul className="list-inline mb-0">
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Decide if India is right for your company (and when)</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Avoid costly regulatory and cultural mistakes</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Build a scalable, resilient presence in India</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> See India as a partner in global competitiveness, not just a “market”</li>
                                </ul>

                            </div>
                        </div>
                        <div className="col-lg-6 col-md-5">
                            <div className="me-lg-5">
                                <img src={heroImg2} className="img-fluid rounded" alt="" />
                            </div>
                        </div>

                    </div>
                </div>
                <div className="container">
                    <div className="row align-items-center mt-5">
                    <div className="col-lg-6 col-md-5">
                            <div className="me-lg-5">
                                <img src={heroImg3} className="img-fluid rounded" alt="" />
                            </div>
                        </div> 
                        <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <div className="title-heading mt-4">
                                <h1 className="heading mb-3">Guide to Mini-Series 1</h1>
                              <div className="flex-1">
                                  <h5 className="widget-title mb-0">Episode 0: When Smart Money Makes Dumb Mistakes</h5>
                                  <p className="text-primary mb-0">The paradox of why global giants fail while others thrive.</p>
                              </div>

                              <div className="flex-1">
                                  <h5 className="widget-title mb-0">Episode 1: Is India Inevitable?</h5>
                                  <p className="text-primary mb-0">Why India is no longer optional for competitive companies.</p>
                              </div>

                              <div className="flex-1">
                                  <h5 className="widget-title mb-0">Episode 2: The New India — Infra, Innovation, Inclusion</h5>
                                  <p className="text-primary mb-0">What’s changed in India and why it matters for you.</p>
                              </div>

                              <div className="flex-1">
                                  <h5 className="widget-title mb-0">Episode 3: The India Entry Paradox — Why Most Fail</h5>
                                  <p className="text-primary mb-0">Common mistakes and how to avoid them.</p>
                              </div>

                              <div className="flex-1">
                                  <h5 className="widget-title mb-0">Episode 4: The Execution Playbook — From Entry to Optimization</h5>
                                  <p className="text-primary mb-0">Practical steps for evaluating, entering, and scaling.</p>
                              </div>

                              <div className="flex-1">
                                  <h5 className="widget-title mb-0">Episode 5: Stories from the Frontier</h5>
                                  <p className="text-primary mb-0">Real-world pivots and success stories.</p>
                              </div>

                              <div className="flex-1">
                                  <h5 className="widget-title mb-0">Episode 6: The Future Advantage</h5>
                                  <p className="text-primary mb-0">AI, climate, and digital governance opportunities.</p>
                              </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-title mb-4 pb-2">
                                <h4 className="title mb-4">Latest Episode</h4>
                                <p className="text-muted ">Why do some of the world’s smartest companies fail in India while others thrive? In this kickoff episode of Bridge to Bharath, hosts Siva Bala Narayanan and Manjunath explore the paradox of India entry through real stories: a German manufacturer’s €2.3M failure versus Schibsted, Micron, and HubSpot’s rapid success.</p>
                                <p className="text-muted ">We introduce the six-part miniseries that will walk you from “Should we even consider India?” to “How do we scale successfully here?” Expect candid lessons, case studies, and a practical playbook for navigating India without the million-dollar mistakes.</p>
                               <PodcastPlayer3 />
                            </div>
                        </div>
                    </div>
                    {/* <div className="container mt-4">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 col-md-9 text-center">
                                <ClientFour />
                            </div>
                        </div>
                    </div> */}
                </div>

                {/* <div className="container">
                    <div className="row align-items-center mt-5">
 
                        <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <div className="title-heading mt-4">
                                <h1 className="heading mb-3">Executive Summary Download</h1>
                                <p className="para-desc text-muted">Companion to the first mini-series — your 8-page roadmap to evaluating, entering, and scaling in India.</p>
                                <ul className="list-inline mb-0">
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Distills the 3-stage execution framework: Evaluate → Enter → Optimize</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Case studies: Micron, HubSpot, Schibsted</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> The 4 failure patterns that cost companies millions</li>
                                </ul>
                                <div className="col-12 mt-4 d-flex justify-content-center">
                                    <Link to="/bridge" className="btn btn-primary">
                                        <i className="mdi mdi-phone-outline"></i> Download Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-5">
                            <div className="me-lg-5">
                                <img src={heroImg4} className="img-fluid rounded" alt="" />
                            </div>
                        </div> 
                    </div>
                </div> */}
                <div className="container">
                    <div className="row align-items-center mt-5">
                    <div className="col-lg-6 col-md-5">
                            <div className="me-lg-5">
                                <img src={heroImg5} className="img-fluid rounded" alt="" />
                            </div>
                        </div> 
                        <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <div className="title-heading mt-4">
                                <h1 className="heading mb-3">Why Work With Pioneer One Global?</h1>
                                <p className="para-desc text-muted">The podcast gives you the frameworks. We help you execute them.</p>
                                <p className="para-desc text-muted">Engagement Models</p>               <ul className="list-inline mb-0">
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Market Intelligence & Readiness</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Entry Strategy & Execution</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Growth Acceleration</li>
                                    <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>Crisis Navigation</li>
                                </ul>
                                <div className="col-12 mt-4 d-flex justify-content-center">
                                    <Link to="https://calendly.com/pioneeroneglobal/30min" className="btn btn-primary">
                                        <i className="mdi mdi-phone-outline">Book Your Free 30-Minute India Readiness Assessment</i> 
                                        </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
  
            </section>
            <div className="row">
          <div className="col-md-6 col-12 mt-4 pt-2">
  <div className="team-list position-relative overflow-hidden shadow rounded text-center p-4">
  <img src={aboutImg2} style={{ height: '100' }} className="img-fluid shadow-lg rounded-top-pill rounded-bottom-5" alt="" />
  
     <h5 className="title mb-0">Siva Bala Narayanan</h5>
    <p className="text-muted mt-3">
    Siva Bala Narayanan is the founder of Pioneer One Global. Having spent half his life in India and the other half in the U.S., he helps global companies navigate the complexity and promise of India. A marathon runner, former chess coach, and lifelong student of the Bhagavad Gita, Siva believes that real growth — whether in business, personal life, or nation-building — begins with mindset, discipline, and inner clarity. As a parent of three daughters raised with both roots and wings, he now extends that philosophy through this podcast: an invitation to reflect, take responsibility, and shape India’s future story.
    </p>
    <div className="col-12 mt-4 d-flex justify-content-center">
      <Link to="/bridgetobharath" className="btn btn-primary">
        <i className="mdi mdi-phone-outline"></i> More about Siva
      </Link>
    </div>
  </div>
</div>
<div className="col-md-6 col-12 mt-4 pt-2">
  <div className="team-list position-relative overflow-hidden shadow rounded text-center p-4">
     <img src={aboutImg3} style={{ height: '25' }} className="img-fluid shadow-lg rounded-top-pill rounded-bottom-5" alt="" />

    <h5 className="title mb-0">Manjunath Subramaniam</h5>
    <p className="text-muted mt-3">
    Manjunath is the co-host of Bridge to Bharath and a partner at Pioneer One Global. Based in Chennai, he has built and led a 40+ person consulting firm that has helped international companies establish and grow their operations in India. With decades of on-the-ground experience, he understands both the promise and the pitfalls of the India market — from navigating regulations to scaling operations. Rooted in India’s entrepreneurial fabric yet attuned to global business expectations, Manjunath bridges cultures, strategies, and execution. His passion lies in making India not just accessible but truly workable for decision-makers worldwide. 
    {/* Through this podcast, he shares the lessons, case studies, and practical insights that come from helping companies succeed in India every day. */}
    </p>
    <div className="col-12 mt-4 d-flex justify-content-center">
      <Link to="/podcast" className="btn btn-primary">
        <i className="mdi mdi-phone-outline"></i> More about Manjunath
      </Link>
    </div>
  </div>
</div>
           </div>
            <Footer />
        </>
    )
}
